// TODO / FIXME: This whole utility component is a temporary solution/hack,
// because we don't currently have a consolidated way of integrating
// "inline-edit" form elements into a DataGroup that aligns nicely,
// hence the magic numbers and the need to look into this
// from a Balance DS level

type childType =
  | 'tags' // for children with height 24px
  | 'small-input' // for children with height 32px
  | 'content-editable'; // for children that are small size content-editable

type Props = {
  childType: childType;
  children: React.ReactNode;
};

export const DataRowInlineEditOffset = ({
  childType = 'small-input',
  children,
}: Props) => {
  const negativeMargin =
    childType === 'small-input' ? 6 : childType === 'content-editable' ? 5 : 2;

  return (
    <div
      css={{
        display: 'inherit',
        marginTop: `-${negativeMargin}px`,
        marginBottom: `-${negativeMargin}px`,
      }}
    >
      {children}
    </div>
  );
};
